module.exports = __webpack_public_path__ + "ajax-loader.gif";